import React from 'react';

const CreateIconImage: React.FC = () => {
  return <img height="17px" width="17px" src="/images/createIcon.svg" alt="Create Icon" />;
};

export default CreateIconImage;
